function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Tab') { return }
  document.body.classList.add('tab-outline')
})

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      if (!!element.nextElementSibling) {
      element.setAttribute('aria-controls', element.nextElementSibling.id);
      }
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.querySelector('.template-popup')?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();

      const videoElement = content.querySelector('video');

      if (videoElement) {
        videoElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.toggleBadge();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateColors();
      this.updateMedia();
      this.updateURL();
      this.updateOtherForms();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateDiscountPrices();
      this.updateUpsellPrices();
      this.updateUpsellComparePrices();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateColors() {
    if (!this.currentVariant) { return; }

    const activeColor = this.querySelector(`[data-varid="${this.currentVariant.id}"]`);
    const parentSection = this.closest('section');

    if (!activeColor || !parentSection) { return; }

    if (activeColor.hasAttribute('data-variant-main-color')) {
      parentSection.style.setProperty('--variant-main-color', activeColor.dataset.variantMainColor);
      parentSection.style.setProperty('--variant-text-color', activeColor.dataset.variantTextColor);
      parentSection.style.setProperty('--variant-border-color', activeColor.dataset.variantBorderColor);

      if (activeColor.hasAttribute('data-variant-disable-background-change')) {
        parentSection.style.removeProperty('--variant-page-color');
      } else {
        parentSection.style.setProperty('--variant-page-color', activeColor.dataset.variantBackgroundColor);
      }
    } else {
      parentSection.style.removeProperty('--variant-main-color');
      parentSection.style.removeProperty('--variant-text-color');
      parentSection.style.removeProperty('--variant-border-color');
      parentSection.style.removeProperty('--variant-page-color');
    }
  }

  updateMedia() {
    document.querySelector('product-gallery')?.updateProductGallery(this.currentVariant)
    document.dispatchEvent(new Event('updateProductGallery'));
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateOtherForms() {
    if (!this.currentVariant || this.hasAttribute('data-is-gc')) return;
    const selectedVariantIndex = document.querySelector(`[data-varid="${this.currentVariant.id}"]`)?.closest('[data-id]')
    const forms = document.querySelectorAll('variant-radios')
    if (forms.length <= 1) return

    forms.forEach(form => {
      const label = form.querySelector(`[data-id="${selectedVariantIndex.dataset.id}"]`)?.querySelector('label')
      label.click()
    })
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  updateDiscountPrices () {
    const regularPrices = document.querySelectorAll('[data-product-price]');
    const salePrices = document.querySelectorAll('[data-product-sale-price]');

    if (document.querySelector('[data-upsell-product-button].active')) { return; }

    regularPrices.forEach((regularPrice) => {
      let priceCents = this.currentVariant.price

      if (regularPrice.hasAttribute('data-product-bundle-discount')) {
        priceCents = this.currentVariant.price - parseFloat(regularPrice.getAttribute('data-product-bundle-discount'))
      }

      regularPrice.innerHTML = Shopify.formatMoney(priceCents, Shopify.money_format);
    });

    salePrices.forEach((salePrice) => {
      if (salePrice.hasAttribute('data-product-bundle-discount')) {
        salePrice.classList.remove('hide');
        salePrice.innerHTML = Shopify.formatMoney(this.currentVariant.price, Shopify.money_format);
      } else {
        if (this.currentVariant.compare_at_price > this.currentVariant.price) {
          salePrice.innerHTML = Shopify.formatMoney(this.currentVariant.compare_at_price, Shopify.money_format);
          salePrice.classList.remove('hide');
        } else {
          salePrice.classList.add('hide');
        }
      }
    });
  }

  updateUpsellPrices() {
    const upsellProductPrices = document.querySelectorAll('[data-upsell-product-price]');

    upsellProductPrices.forEach((upsellProductPrice) => {
      const upsellProductData = JSON.parse(upsellProductPrice.getAttribute('data-upsell-product-data'))
      const matchingVariant = upsellProductData.variants.find((variant) => variant.option1 === this.currentVariant.option1);

      if (!matchingVariant) { return; }

      if (upsellProductPrice.hasAttribute('data-product-bundle-discount')) {
        const discountValue = upsellProductPrice.getAttribute('data-product-bundle-discount')
        upsellProductPrice.innerHTML = Shopify.formatMoney((matchingVariant.price - discountValue), Shopify.money_format);
      } else {
        upsellProductPrice.innerHTML = Shopify.formatMoney(matchingVariant.price, Shopify.money_format);
      }
    });
  }

  updateUpsellComparePrices() {
    const upsellComparePrices = document.querySelectorAll('[data-upsell-product-compare-price]');

    upsellComparePrices.forEach((upsellComparePrice) => {
      const upsellProductData = JSON.parse(upsellComparePrice.getAttribute('data-upsell-product-data'))
      const matchingVariant = upsellProductData.variants.find((variant) => variant.option1 === this.currentVariant.option1);

      if (!matchingVariant) { return; }

      if (matchingVariant.compare_at_price > matchingVariant.price) {
        upsellComparePrice.classList.remove('hide');
        upsellComparePrice.innerHTML = Shopify.formatMoney(matchingVariant.compare_at_price, Shopify.money_format);
      } else if (upsellComparePrice.hasAttribute('data-product-bundle-discount')) {
        upsellComparePrice.classList.remove('hide');
        upsellComparePrice.innerHTML = Shopify.formatMoney(matchingVariant.price, Shopify.money_format);
      }
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  toggleBadge () {
    const id = this.currentVariant?.id || ''
    const badges = document.querySelector('.main-product').querySelectorAll('[data-badge-id]')
    badges.forEach(badge => {
      badge.classList.toggle('hide', Number(badge.dataset.badgeId) !== id)
    })
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.fieldset = this.querySelector('fieldset');
  }

  connectedCallback() {
    this.fieldset.addEventListener('change', () => this.fieldsetChange());
  }

  fieldsetChange() {
    this.fieldset.querySelector('input:checked').closest('div').querySelector('label').click();

    let price = this.querySelector('input[data-varid]:checked')?.value;

    if (price) {
      $(`.variant-atcs .add-to-cart`).text(`${price} - ${window.variantStrings.addToCart}`)
      $('[data-buy-bar-button]').text(`${price} - ${window.variantStrings.addToCart}`)
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


/* SLIDERS */
// Categories slider
$('.categories-slider__container').slick({
  slidesToShow: 3,
  prevArrow: '<button type="button" class="slick-prev h1" aria-label="Previous slide">←</button>',
  nextArrow: '<button type="button" class="slick-next h1" aria-label="Next slide">→</button>',
  infinite: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        arrows: false
      }
    }
  ]
});

// Reviews slider
$('.reviews-slider__container').slick({
  slidesToShow: 3,
  prevArrow: '<button type="button" class="slick-prev h1" aria-label="Previous slide">←</button>',
  nextArrow: '<button type="button" class="slick-next h1" aria-label="Next slide">→</button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        arrows: false,
        dots: true
      }
    }
  ]
});

// Blog slider
$('.blog-slider__articles').slick({
  slidesToShow: 3,
  prevArrow: '<button type="button" class="slick-prev h1 small-hide" aria-label="Previous slide">←</button>',
  nextArrow: '<button type="button" class="slick-next h1 small-hide" aria-label="Next slide">→</button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        infinite: false
      }
    }
  ]
});

// Testimonial slider
$('.testimonials__container').slick({
  slidesToShow: 3,
  arrows: false,
  infinite: false,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 2,
        arrows: false,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        arrows: false,
        dots: true
      }
    }
  ]
});

// Image + Content Carousel slider
$('[data-image-content-carousel-slider]').each(function (i) {
  if ($(this).children().length > 1) {
    $(this).slick({
      arrows: true,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous slide"><svg aria-hidden="true" focusable="false" role="presentation" width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.182 1.63623L1.818 8.00023L8.182 14.3642" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next slide"><svg aria-hidden="true" focusable="false" role="presentation" width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.81799 1.63623L8.18199 8.00023L1.81799 14.3642" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
    })
  }
})

$('.pdp-slider__slider').slick({
  centerMode: true,
  variableWidth: true,
  infinite: false,
  prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous slide"><svg aria-hidden="true" focusable="false" role="presentation" width="27" height="19" viewBox="0 0 27 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.7632 8.23661H5.48719L14.0192 0.964606H9.62719L0.843188 8.41661V11.2246L9.62719 18.6046H14.0192L5.48719 11.3326H26.7632V8.23661Z" fill="black"/></svg></button>',
  nextArrow: '<button class="slick-next slick-arrow" aria-label="Next slide"><svg aria-hidden="true" focusable="false" role="presentation" width="27" height="19" viewBox="0 0 27 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.8352 0.964606H13.4432L21.9752 8.23661H0.699188V11.3326H21.9752L13.4432 18.6046H17.8352L26.6192 11.2246V8.41661L17.8352 0.964606Z" fill="black"/></svg></button>',
  slidesToShow: 3,
  initialSlide: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: true,
        slidesToShow: 1
      }
    }
 ]
})

$('.pdp-slider__slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
  if (currentSlide == 1) {
	$('.pdp-slider__slider .slick-prev').css('pointer-events', 'none')
    $('.pdp-slider__slider .slick-next').css('pointer-events', 'unset')
  } else if (currentSlide == slick.slideCount - 2) {
    $('.pdp-slider__slider .slick-prev').css('pointer-events', 'unset')
    $('.pdp-slider__slider .slick-next').css('pointer-events', 'none')
  } else {
    $('.pdp-slider__slider .slick-prev').css('pointer-events', 'unset')
    $('.pdp-slider__slider .slick-next').css('pointer-events', 'unset')
  }
});

$('.landing-slider__slider').slick({
  infinite: true,
  arrows: false,
  dots: true
});

$('.info-blocks-slider').slick({
  infinite: true,
  arrows: false,
  dots: false,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 3000,
});


$('.form-block').click(function() {
  const index = $(this).attr('data-id')

  $('.form-header').removeClass('active');
  $('.form-block').removeClass('active');

  $(`.form-block[data-id="${index}"]`).addClass('active');
  $(`.form-block[data-id="${index}"] .form-header`).addClass('active');

  let selected_kit = $('.form-header.active .product__title').text()
  $('.buybox-title span').text(`${selected_kit}`)

  let selected_block = Number($('.form-block.active').data('id'))
  $('.variant-atcs').hide()
  $('.variant-atcs').removeClass('active')
  $(`.variant-atcs[data-id="${selected_block}"]`).show()
  $(`.variant-atcs[data-id="${selected_block}"]`).addClass('active')

  let price = $(this).find('.pay-price').text()
  $(`.variant-atcs[data-id="${selected_block}"] .add-to-cart`).text(`${price} - ${window.variantStrings.addToCart}`)
  $('[data-buy-bar-button]').text(`${price} - ${window.variantStrings.addToCart}`)

  setTimeout(() => {
    let price = $(this).find('.pay-price').text()
    $(`.variant-atcs[data-id="${selected_block}"] .add-to-cart`).text(`${price} - ${window.variantStrings.addToCart}`)
    $('[data-buy-bar-button]').text(`${price} - ${window.variantStrings.addToCart}`)
  }, 50);

  $('.form-header').each(function(index, value) {
    if ($(value).hasClass('active')) {
	  $(value).next().slideDown()
    } else {
      $(value).next().slideUp()
    }
  })
})

$('[data-buy-bar-link]').click(function (event) {
  const link = event.currentTarget
  if (link.getAttribute('href').startsWith('#')) {
    event.preventDefault()
    $([document.documentElement, document.body]).animate({
      scrollTop: $(link.getAttribute('href')).offset().top
    }, 500);
  }
})

$('.main-product .is-color').click(function() {
  const onSaleMessage = $(this).attr('data-swatch-on-sale-message')

  if (onSaleMessage) {
    $(this).closest('.product').find('[data-sale-badge]').removeClass('hide');
    $(this).closest('.product').find('[data-sale-badge]').text(onSaleMessage);
  } else {
    $(this).closest('.product').find('[data-sale-badge]').addClass('hide');
  }

  $(this).closest('.product').find('.is-color').removeClass('selectedColor')
  setTimeout(() => $(this).addClass('selectedColor'), 50);

  $(this).closest('.product').find('.multi-product-atc, .no-sub__atc, .sub__atc').text($(this).data('available'))
  let color = $(this).data('limited')
  $(this).closest('.product').find('.limited-color').css('visibility','visible')
  $(this).closest('.product').find('.limited-color p').text(`${color}`)

  if ($(this).data('inventory') < 1 && $(this).hasClass('oos')) {
   $(this).closest('.product').find('.add-to-cart').text('Out of stock').prop("disabled",true);
  } else if ($(this).data('inventory') < 1) {
   $(this).closest('.product').find('.add-to-cart').hide()
   $(this).closest('.product').find('.klaviyo-bis-trigger').show()
  } else {
    $(this).closest('.product').parent().find('.add-to-cart').prop("disabled",false);
    $(this).closest('.product').find('.add-to-cart').show()
    $(this).closest('.product').find('.klaviyo-bis-trigger').hide()
  }

  $('.form-header.active').click();
})

setTimeout(() => $('.form-header.active').click(), 100);

$(".colors-column label").click(function() {
  $(".colors-column label").css("text-decoration","none")
  $(this).css("text-decoration","underline")
})

$('.page-gift-bundle-collections .is-color').click(function() {
  $(this).closest('.product').find('.is-color.selectedColor').removeClass('selectedColor')
  $(this).addClass('selectedColor')
})

$(document).ready(function() {
  $('.selectedColor').click();
});

// No-sub add to cart buttons
const addToCartButtons = document.querySelectorAll('.no-sub__atc')

addToCartButtons.forEach(addToCartButton => {
  addToCartButton.addEventListener('click', () => {
    const parentEl = addToCartButton.closest('[data-product-atc-wrap]')

    const valsEl = parentEl.querySelector('.vals')
    let id;
    if (valsEl && ['Denomination', 'Amounts'].includes(valsEl.dataset.id)) {
      const activeInput = parentEl.querySelector('.vals input:checked')
      id = Number(activeInput.getAttribute('data-varid'))
    } else {
      id = Number(parentEl.querySelector('.is-color.selectedColor').getAttribute('data-varid'))
    }

    const body = JSON.stringify({
      items: [{
        id: id,
        quantity: 1
      }],
      sections: getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        document.querySelector('cart-drawer').open();
      });
    })
})

// Add to cart
$('.subcollection__atc').click(function() {
  let id = Number($(this).data('id'));
  let subid = Number($(this).data('subid'));
  let add_items;

  if (!!subid) {
    add_items = [{id: id,quantity: 1,selling_plan: subid}]
  } else {
    add_items = [{ id: id, quantity: 1 }]
  }

  const body = JSON.stringify({
    items: add_items,
    sections: getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname
  });

  fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
    .then((response) => response.json())
    .then((parsedState) => {
      getSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML =
          getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      document.querySelector('cart-drawer').open();
    });
});

function getSectionsToRender() {
  return [
    {
      id: 'cart-drawer__content',
      section: document.getElementById('cart-drawer__content').dataset.id,
      selector: '.cart-drawer__content',
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    },
    {
      id: 'cart-drawer__header',
      section: document.getElementById('cart-drawer__header').dataset.id,
      selector: '.cart-drawer__header',
    },
    {
      id: 'cart-drawer__footer',
      section: document.getElementById('cart-drawer__footer').dataset.id,
      selector: '.cart-drawer__footer',
    }
  ];
}

function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}


$(document).ready(function() {
  var maxHeight = 0;

  $(".text-icons__item .body").each(function(){
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();
    }
  });

   $(".text-icons__item .body").height(maxHeight);


  // $('.ships').text($('.is-color.selectedColor').data('ships'))
  $('.multi-product-atc, .no-sub__atc, .sub__atc').text($('.is-color.selectedColor').data('available'))

  let color = $('.is-color.selectedColor').data('limited')
  $('.is-color.selectedColor').closest('.product').find('.limited-color').css('visibility','visible')
  $('.is-color.selectedColor').closest('.product').find('.limited-color p').text(`${color}`)


  // if ($('.is-color.selectedColor').data('inventory') < 1 && $('.is-color.selectedColor').hasClass('oos')) {
  //   $('.is-color.selectedColor').parent().parent().parent().parent().parent().next().find('.add-to-cart').text('Out of stock').prop("disabled",true);
  // } else if ($('.is-color.selectedColor').data('inventory') < 1) {
  //   $('.is-color.selectedColor').parent().parent().parent().parent().parent().next().find('.add-to-cart').hide()
  //   $('.is-color.selectedColor').parent().parent().parent().parent().parent().next().find('.klaviyo-bis-trigger').show()
  // } else {
  //   $('.is-color.selectedColor').parent().parent().parent().parent().parent().next().find('.add-to-cart').show()
  //   $('.is-color.selectedColor').parent().parent().parent().parent().parent().next().find('.klaviyo-bis-trigger').hide()
  // }

  if ($('.is-color.selectedColor').data('inventory') < 1 && $('.is-color.selectedColor').hasClass('oos')) {
   $('.add-to-cart').hide();
  } else if ($('.is-color.selectedColor').data('inventory') < 1) {
   $('.add-to-cart').text('Out of stock').prop("disabled",true);
  } else {
    if ($(this).data('inventory') >= 1) {
      $(this).closest('.product').find('.add-to-cart').text(`${window.variantStrings.addToCart}`).prop("disabled",false);
    }
    $(this).closest('.product').next().find('.add-to-cart').show()
    $(this).closest('.product').find('.klaviyo-bis-trigger').hide()
  }

  let selected_kit = $('.form-header.active .product__title').text()
  $('.buybox-title span').text(`${selected_kit}`)

   let selected_block = Number($('.form-block.active').data('id'))
   $(`.variant-atcs[data-id="${selected_block}"]`).show()
})

$('.main-product .multi-product-atc').click(function() {
  let id = Number($(this).parent().parent().find('.is-color.selectedColor').data('varid'))
  let sub_prod1_id = Number($(this).parent().find('.subupsell1').data('id'))
  let sub_prod1_subid = Number($(this).parent().find('.subupsell1').data('subid'))
  let sub_prod2_id = Number($(this).parent().find('.subupsell2').data('id'))
  let sub_prod2_subid = Number($(this).parent().find('.subupsell2').data('subid'))
  const kitID = $(this).data('kit-id');
  let shipping_prop = $('.is-color.selectedColor').data('ships')
  let items_group;
  let custom_properties;

  if (shipping_prop !== 'SHIPS NOW') {
    custom_properties = {"_kitID": kitID, "Shipping": shipping_prop }
  } else {
    custom_properties = {"_kitID": kitID}
  }

  if (!!id && !!sub_prod1_id && !!sub_prod2_id) {
    items_group = [
	{
      id: sub_prod1_id,
      quantity: 1,
      selling_plan: sub_prod1_subid,
      properties: {
        "_kitID": kitID
      }
	},
	{
      id: sub_prod2_id,
      quantity: 1,
      selling_plan: sub_prod2_subid,
      properties: {
        "_kitID": kitID
      }
	},
	{
      id: id,
      quantity: 1,
      properties: custom_properties
    }]


  } else if (!!sub_prod1_id && !!sub_prod2_id && !id) {
    items_group = [
	{
      id: sub_prod1_id,
      quantity: 1,
      selling_plan: sub_prod1_subid,
      properties: {
        "_kitID": kitID
      }
	},
	{
      id: sub_prod2_id,
      quantity: 1,
      selling_plan: sub_prod2_subid,
      properties: {
        "_kitID": kitID
      }
	}]
  } else {
    items_group = [
	{
      id: sub_prod1_id,
      quantity: 1,
      selling_plan: sub_prod1_subid,
      properties: {
        "_kitID": kitID
      }
	},
    {
      id: id,
      quantity: 1,
      properties: custom_properties
    }]
  }

  const body = JSON.stringify({
    items: items_group,
    sections: getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname
  });


  fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
    .then((response) => response.json())
    .then((parsedState) => {
      getSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML =
          getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));

    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      document.querySelector('cart-drawer').open();
    });
})


$('.main-product .multi-product-atc').click(function() {
  let id = Number($(this).parent().find('.is-color.selectedColor').data('varid'))
  let sub_prod1_id = Number($(this).parent().find('.subupsell1').data('id'))
  let sub_prod1_subid = Number($(this).parent().find('.subupsell1').data('subid'))
  let sub_prod2_id = Number($(this).parent().find('.subupsell2').data('id'))
  let sub_prod2_subid = Number($(this).parent().find('.subupsell2').data('subid'))
  const kitID = $(this).data('kit-id');
  let shipping_prop = $('.is-color.selectedColor').data('ships')
  let items_group;
  let custom_properties;

  if (shipping_prop !== 'SHIPS NOW') {
    custom_properties = {"_kitID": kitID, "Shipping": shipping_prop }
  } else {
    custom_properties = {"_kitID": kitID}
  }

  if (!!id && !!sub_prod1_id && !!sub_prod2_id) {
    items_group = [
	{
      id: sub_prod1_id,
      quantity: 1,
      selling_plan: sub_prod1_subid,
      properties: {
        "_kitID": kitID
      }
	},
	{
      id: sub_prod2_id,
      quantity: 1,
      selling_plan: sub_prod2_subid,
      properties: {
        "_kitID": kitID
      }
	},
	{
      id: id,
      quantity: 1,
      properties: custom_properties
    }]


  } else if (!!sub_prod1_id && !!sub_prod2_id && !id) {
    items_group = [
	{
      id: sub_prod1_id,
      quantity: 1,
      selling_plan: sub_prod1_subid,
      properties: {
        "_kitID": kitID
      }
	},
	{
      id: sub_prod2_id,
      quantity: 1,
      selling_plan: sub_prod2_subid,
      properties: {
        "_kitID": kitID
      }
	}]
  } else {
    items_group = [
	{
      id: sub_prod1_id,
      quantity: 1,
      selling_plan: sub_prod1_subid,
      properties: {
        "_kitID": kitID
      }
	},
    {
      id: id,
      quantity: 1,
      properties: custom_properties
    }]
  }

  const body = JSON.stringify({
    items: items_group,
    sections: getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname
  });


  fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
    .then((response) => response.json())
    .then((parsedState) => {
      getSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML =
          getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));

    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      document.querySelector('cart-drawer').open();
    });
})

$('.gift-card__atc').click(function() {
let id = Number($(this).parent().parent().find('input:checked+label').data('varid'))

  const body = JSON.stringify({
    items: [{
      id: id,
      quantity: 1
    }],
    sections: getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname
  });

  fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
    .then((response) => response.json())
    .then((parsedState) => {
      getSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML =
          getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      document.querySelector('cart-drawer').open();
    });
})


$('.sub__atc').click(function() {
  let id = Number($(this).closest('.product').find('.is-color.selectedColor').data('varid'))
  let sub = Number($(this).closest('.product').find('.variant-atcs.active .is-color.selectedColor').data('sub'))

  const body = JSON.stringify({
    items: [{
      id: id,
      quantity: 1,
      selling_plan: sub
    }],
    sections: getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname
  });

  fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
    .then((response) => response.json())
    .then((parsedState) => {
      getSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML =
          getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      document.querySelector('cart-drawer').open();
    });
})

$('.landing__atc').click(function() {
  let id = Number($(this).data('id'));
  let subid = Number($(this).data('subid'));
  let subplan = Number($(this).data('subplan'));
  const kitID = $(this).data('kit-id');
  let add_items;

  if (!!subid) {
    add_items = [{id: id, quantity: 1, properties: {"_kitID": kitID}},{id: subid, quantity: 1, selling_plan: subplan, properties: {"_kitID": kitID}}]
  } else {
    add_items = [{ id: id, quantity: 1 }]
  }

  const body = JSON.stringify({
    items: add_items,
    sections: getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname
  });

  fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
    .then((response) => response.json())
    .then((parsedState) => {
      getSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML =
          getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      document.querySelector('cart-drawer').open();
    });
});

const addToCartButton = document.querySelector('.add-to-cart');

if (addToCartButton) {
  addToCartButton.addEventListener('click', (event) => {
    if (!addToCartButton.hasAttribute('data-bundle-products')) { return; }

    const bundleProductsJSON = JSON.parse(addToCartButton.getAttribute('data-bundle-products'));
    const itemsToAdd = [];
    const kitID = addToCartButton.getAttribute('data-kit-id');

    bundleProductsJSON.forEach((product) => {
      itemsToAdd.push({
        id: product.id,
        quantity: 1,
        properties: {
          "_kitID": kitID,
          "_hide": product.hide
        }
      });
    });

    const body = JSON.stringify({
      items: itemsToAdd,
      sections: getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
    .then((response) => response.json())
    .then((parsedState) => {
      getSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML =
          getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      document.querySelector('cart-drawer').open();
    });
  });
}

$(document).ready(function() {
  if (window.location.pathname == '/pages/sephora') {
    window.location.href = "https://www.sephora.com/product/canopy-the-canopy-humidifier-starter-set-P481408?skuId=2569713&icid2=products%20grid:p481408:product";
  }
})

// nok

$( ".nok-hover" ).click(function() {
  if ($(window).width() < 768) {
    $('.nok-tooltip-mobile').toggle()
  } else {
    $('.nok-tooltip').toggle()
  }

  $('.page-overlay').css({"visibility": "visible", "opacity": 1})
})


$( ".tooltip-x, .nok-tooltip-mobile" ).click(function() {
 $('.nok-tooltip').hide()
 $('.nok-tooltip-mobile').hide()
 $('.page-overlay').css({"visibility": "hidden", "opacity": 0})
})


$('.blog-category-dropdown-header').click(function() {
  $('.blog-category-dropdown-body').slideToggle();
  $(this).toggleClass('active');
})


$('.get-humidity-input').keypress(function (e) {
 var key = e.which;
 if(key == 13)  // the enter key code
  {
    $('.get-humidity').click();
    return false;
  }
});

$('.get-uv-index-input').keypress(function (e) {
 var key = e.which;
 if(key == 13)  // the enter key code
  {
    $('.get-uv-index').click();
    return false;
  }
});

$('.get-wind-chill-input').keypress(function (e) {
 var key = e.which;
 if(key == 13)  // the enter key code
  {
    $('.get-wind-chill').click();
    return false;
  }
});


$('.get-humidity').click(function(e) {
  let str = $('.get-humidity-input').val()
  async function getData(){
      let response = await fetch(`http://api.weatherapi.com/v1/current.json?key=c0c9e3cfda2b41a39d2221038230301&q=${str}&aqi=yes`);
      let data = await response.json()
      return data;
  }

  getData().then(data => {
   if (!!data.error) {
      $('.humidity-info__outputs').slideUp();
     if (data.error.message == 'No matching location found.') {
       $('.humidity-info__error').text(`${data.error.message}`).show()
     } else {
       $('.humidity-info__error').text('Please enter a location.').show()
     }
   } else {
     $('.humidity-info__error').hide()
     $('.humidity-info__outputs').slideDown();
     $('.humidity-output').text(`${data.current.humidity}%`)
     $('.temperature-output').text(`${data.current.temp_f} °F`)
     $('.wind-output').text(`${data.current.feelslike_f} °F`)
   }
  })
})

$('.get-wind-chill').click(function(e) {
  let str = $('.get-wind-chill-input').val()
  async function getData(){
      let response = await fetch(`http://api.weatherapi.com/v1/current.json?key=c0c9e3cfda2b41a39d2221038230301&q=${str}&aqi=yes`);
      let data = await response.json()
      return data;
  }

  getData().then(data => {
   if (!!data.error) {
      $('.humidity-info__outputs').slideUp();
     if (data.error.message == 'No matching location found.') {
       $('.humidity-info__error').text(`${data.error.message}`).show()
     } else {
       $('.humidity-info__error').text('Please enter a location.').show()
     }
   } else {
     let chill = 35.74 + (0.6215*Number(data.current.temp_f)) - 35.75*Math.pow(Number(data.current.wind_mph),0.16) + 0.4275*Number(data.current.temp_f)*Math.pow(Number(data.current.wind_mph),0.16)
     let chilltemp
     if ((data.current.temp_f - chill).toFixed(1) > 0 ) {
       chilltemp = (data.current.temp_f - chill).toFixed(1)
     } else {
       chilltemp = 0
     }
     $('.humidity-info__error').hide()
     $('.humidity-info__outputs').slideDown();
     $('.speed-output').text(`${data.current.wind_mph} MPH`)
     $('.humidity-output').text(`${data.current.wind_dir}`)
     $('.wind-output').text(`${chilltemp} °F`)
     $('.temperature-output').text(`${data.current.feelslike_f} °F`)
   }
  })
})

$('.get-uv-index').click(function(e) {
  let str = $('.get-uv-index-input').val()
  async function getData(){
      let response = await fetch(`http://api.weatherapi.com/v1/current.json?key=c0c9e3cfda2b41a39d2221038230301&q=${str}&aqi=yes`);
      let data = await response.json()
      return data;
  }

  getData().then(data => {
   if (!!data.error) {
      $('.humidity-info__outputs').slideUp();
     if (data.error.message == 'No matching location found.') {
       $('.humidity-info__error').text(`${data.error.message}`).show()
     } else {
       $('.humidity-info__error').text('Please enter a location.').show()
     }
   } else {
     $('.humidity-info__error').hide()
     $('.humidity-info__outputs').slideDown();
     $('.temperature-output').text(`${data.current.temp_f} °F`)
     $('.wind-output').text(`${data.current.uv}`)
   }
  })
})

$('.mini-faq__q').click(function() {
  $(this).parent().find('.mini-faq__a').slideToggle()
  $(this).find('.arrow').toggleClass('rotate')
});

// simple-video component
var SimpleVideo = class extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector("video");
    this.playBtn = this.querySelector("[data-simple-video-play-btn]");
    this.pauseBtn = this.querySelector("[data-simple-video-pause-btn]");

    this.initSimpleVideo();
  }
  initSimpleVideo() {
    if (!this.video) { return; }

    this.playBtn.addEventListener('click', (event) => {
      event.preventDefault();
      this.video.play();
      this.classList.remove("simple-video--paused");
    });

    this.pauseBtn.addEventListener('click', (event) => {
      event.preventDefault();
      this.video.pause();
      this.classList.add("simple-video--paused");
    });
  }
};
if (!window.customElements.get("simple-video")) {
  window.customElements.define("simple-video", SimpleVideo);
}

var SiteNav = class extends HTMLElement { // eslint-disable-line
  constructor () {
    super()
    this.menuBar = this.querySelector('ul')
    this.menuItems = this.menuBar.querySelectorAll(':scope > li[tabindex="0"], :scope > li > a, :scope > li > button')
    this.dropdownWrappers = this.querySelectorAll('[data-dropdown-wrapper]')
    this.scope = null
    this.tabbableElements = null
    this.menuOpen = false
    this.userIsTabbing = false

    // Set to true if it is needed for dropdown titles to also be clickable as a link.
    this.allowDropdownTriggerLinks = true
    this.desktopBreakpoint = 1023

    this.initDropdowns()
    this.initKeybinds()
  }

  initDropdowns () {
    this.dropdownWrappers.forEach(dropdownWrapper => {
      const trigger = dropdownWrapper.querySelector('[data-dropdown-open]')

      trigger?.addEventListener('click', (event) => {
        if (window.innerWidth > this.desktopBreakpoint && this.allowDropdownTriggerLinks) { return }
        event.preventDefault()
        this.toggleDropdown(dropdownWrapper)
      })
    })
  }

  openDropdown (wrapperEl) {
    const trigger = wrapperEl.querySelector('[data-dropdown-open]')
    const dropdown = wrapperEl.querySelector('[data-dropdown]')

    wrapperEl.classList.add('active')
    trigger?.setAttribute('aria-expanded', 'true')
    dropdown?.setAttribute('aria-hidden', 'false')
    this.menuOpen = true
  }

  toggleDropdown (wrapperEl) {
    const trigger = wrapperEl.querySelector('[data-dropdown-open]')
    const dropdown = wrapperEl.querySelector('[data-dropdown]')

    wrapperEl.classList.toggle('active')
    const isActive = wrapperEl.classList.contains('active')
    trigger?.setAttribute('aria-expanded', isActive)
    dropdown?.setAttribute('aria-hidden', !isActive)
    this.menuOpen = isActive
  }

  closeAllDropdowns () {
    this.dropdownWrappers.forEach(dropdownWrapper => {
      const trigger = dropdownWrapper.querySelector('[data-dropdown-open]')
      const dropdown = dropdownWrapper.querySelector('[data-dropdown]')

      dropdownWrapper.classList.remove('active')
      trigger?.setAttribute('aria-expanded', 'false')
      dropdown?.setAttribute('aria-hidden', 'true')
    })
  }

  initKeybinds () {
    document.body.addEventListener('focusin', () => {
      const activeElement = document.activeElement

      // Not in the nav, do nothing
      if (!activeElement.closest('site-nav') && !this.userInNav) { return }

      // Leaving or moving in the nav, let's rest the dropdowns
      this.closeAllDropdowns()

      // Leaving the nav, turn off some settings
      if (!activeElement.closest('site-nav') && this.userInNav) {
        this.menuOpen = false
        this.userInNav = false
        return
      }

      // We are in the nav. If there should be an open dropdown, open it
      const dropdownWrapper = activeElement.closest('[data-dropdown-wrapper]')
      if (dropdownWrapper && this.menuOpen) {
        this.openDropdown(dropdownWrapper)
      }

      // If we just entered the nav, scope the top level menu items
      if (!this.userInNav) {
        this.setScope(this)
      }
      this.userInNav = true
    })

    document.addEventListener('keydown', (event) => {
      if (!this.userInNav || event.metaKey || event.shiftKey || event.ctrlKey) { return }
      if (!this.userIsTabbing && event.code === 'Tab') {
        this.userIsTabbing = true
      }

      if (!this.scope) { return false }

      // If a key between A and Z is pressed, select the first or next element where the text corresponds to this letter.
      if (event.keyCode >= 65 && event.keyCode <= 90) {
        this.focusChar(event)
        return
      }

      // Make the space key work like enter on nav
      if (event.code === 'Space') {
        event.preventDefault()
        event.target.click()
        return
      }

      const dropdownWrapper = event.target.closest('[data-dropdown-wrapper]')

      switch (event.key) {
        case 'Escape':
          this.closeAllDropdowns()
          this.menuOpen = false
          break
        case 'ArrowUp':
          if (!dropdownWrapper) { return }

          if (event.target.hasAttribute('data-nav-link')) {
            this.openDropdown(dropdownWrapper)
            this.setScope(dropdownWrapper.querySelector('[data-dropdown]'))
            this.focusEnd(event, 'last')
          } else {
            this.focus(event, -1)
          }
          break
        case 'ArrowDown':
          if (!dropdownWrapper) { return }

          if (event.target.hasAttribute('data-nav-link')) {
            this.openDropdown(dropdownWrapper)
            this.setScope(dropdownWrapper.querySelector('[data-dropdown]'))
            this.focusEnd(event, 'first')
          } else {
            this.focus(event, 1)
          }
          break
        case 'ArrowRight':
          this.setScope(this)
          this.focus(event, 1, dropdownWrapper ? event.target.closest('[data-dropdown-wrapper]').querySelector('[data-nav-link]') : document.activeElement)
          break
        case 'ArrowLeft':
          this.setScope(this)
          this.focus(event, -1, dropdownWrapper ? event.target.closest('[data-dropdown-wrapper]').querySelector('[data-nav-link]') : document.activeElement)
          break
        case 'Home' :
          this.focusEnd(event, 'first')
          break
        case 'End' :
          this.focusEnd(event, 'last')
          break
      }
    })
  }

  // Set the current menu scope to focus items within
  setScope (element) {
    this.scope = element
    this.tabbableElements = element === null ? null : (element.tagName.toLowerCase() === 'site-nav' ? this.menuItems : element.querySelectorAll('a[href], button:not(.disabled)'))
    this.tabbableElements.forEach((element) => {
      element.setAttribute('tabindex', 0)
    });
    this.tabbableElements[0].focus();
  }

  // Focus element in a direction, 1 for next, -1 for previous
  focus (event, dir, targetElement = document.activeElement, array = this.tabbableElements) {
    event.preventDefault()
    const count = array.length - 1
    let focusIndex = [...array].findIndex(child => child === targetElement) + dir
    focusIndex = focusIndex < 0 ? count : focusIndex
    focusIndex = focusIndex > count ? 0 : focusIndex

    array[focusIndex].focus()
  }

  // Focus first or last element
  focusEnd (event, pos) {
    event.preventDefault()
    const target = pos === 'first' ? 0 : this.tabbableElements.length - 1
    const targetElement = this.tabbableElements[target]

    setTimeout(() => {
      targetElement.focus()
    }, 100);
  }

  // Focus first or next where the text content's first letter matches the pressed key.
  focusChar (event) {
    event.preventDefault()
    // Find all elements where the first letter is the pressed key AND the active element
    const relevantArray = [...this.tabbableElements].filter(child => child.textContent.trim().toLowerCase().charAt(0) === event.key || child === document.activeElement)
    // Get current active element index
    const activeIndex = [...relevantArray].findIndex(child => child === document.activeElement)
    // Offset the array by the current active element. Allows using the focus function to select the next/prev
    const offsetArray = this.offsetArray(relevantArray, activeIndex)
    // Get only the relevant key items (removes active element if it does not match)
    const characterArray = [...offsetArray].filter(child => child.textContent.trim().toLowerCase().charAt(0) === event.key)
    if (!characterArray.length) { return }

    this.focus(event, 1, undefined, characterArray)
  }

  offsetArray (array, offset) {
    return [...[...array].slice(offset), ...[...array].slice(0, offset)]
  }
};
if (!window.customElements.get('site-nav')) {
  window.customElements.define('site-nav', SiteNav);
}